import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {EmployeeService} from '../../../shared/service/employee.service';
import {EmployeeDesignationService} from '../../../shared/service/employee-designation.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {EmployeeDTO} from '../../../shared/dto/employee.model';
import {EmployeeDesignationDTO} from '../../../shared/dto/employee-designation.model';
import swal from 'sweetalert2';
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import {EmployeePopupComponent} from './employee-popup/employee-popup.component';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.scss']
})
export class EmployeeComponent implements OnInit {
  public employeeForm: FormGroup;
  public employeeDTOS: EmployeeDTO [] = [];
  public employeeDesignationDTOS: EmployeeDesignationDTO [] = [];
  public employeeConfigItems: EmployeeDTO [] = [];
  public href: string = '';

  constructor(private employeeService: EmployeeService,
              private employeeDesignationService: EmployeeDesignationService,
              public modalService: NgbModal,
              private spinnerService: NgxUiLoaderService,
              private tokenStorageService: TokenStorageService,
              private router: Router) {
  }

  ngOnInit() {
    this.employeeForm = new FormGroup({
      employeeDesignation: new FormControl(null),
      name: new FormControl(null),
      states: new FormControl(null),
    });

    this.href = this.router.url;
    this.onLoadGetData();
    this.loadEmployeeDesignations();
    this.loadEmployeeDetails();
  }

  loadEmployeeDetails() {
    this.employeeService.getAllEmployees().subscribe(
      (data: EmployeeDTO[]) => {
        this.employeeConfigItems = data;
      }
    )
  }


  loadEmployeeDesignations() {
    this.employeeDesignationService.getAllEmployeeDesignation().subscribe(
      (data: EmployeeDesignationDTO []) => {
        this.employeeDesignationDTOS = data;
      }
    )
  }

  onLoadGetData(): void {
    const employeeDTO = new EmployeeDTO(
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null
    );

    this.loadSearchResultList(employeeDTO);
  }

  loadSearchResultList(employeeDTO: EmployeeDTO): void {
    this.spinnerService.start();
    this.employeeService.getEmployeeDetails(employeeDTO).subscribe(
      (data: EmployeeDTO[]) => {
        this.employeeConfigItems = data;
      },
      (error) => {
        this.spinnerService.stop();
        swal.fire('Sorry!', 'Something went wrong...!', 'error');
      },
      () => {
        this.spinnerService.stop();
        if (this.employeeConfigItems == null || this.employeeConfigItems.length === 0) {
          this.loadEmployeeDetails();
          swal.fire('Sorry', 'No result found.', 'error');
        } else {
          this.employeeService.clearUserRoleSearchDetails();
          this.employeeService.setUserRoleSearchDetails(
            this.employeeConfigItems
          );
        }
      }
    );
  }

  onSubmitSearch(): void {
    let isValid: boolean = false;
    let msg: string = 'Please fill the form..!';

    if (this.employeeForm.value.employeeDesignation != null) {
      isValid = true;
    }
    if (this.employeeForm.value.name != null) {
      isValid = true;
    }
    if (this.employeeForm.value.states != null) {
      isValid = true;
    }
    if (isValid && this.employeeForm.valid) {
      const employeeDTO = new EmployeeDTO(
        null,
        this.employeeForm.value.name,
        null,
        null,
        null,
        null,
        null,
        this.employeeForm.value.states,
        this.employeeForm.value.employeeDesignation,
        null,
        this.tokenStorageService.getUserObjectToken().username,
        this.href
      );
      this.spinnerService.start();
      this.employeeService.getEmployeeDetails(employeeDTO).subscribe(
        (data: EmployeeDTO[]) => {
          this.employeeConfigItems = data;
        },
        (error) => {
          this.spinnerService.stop();
          swal.fire('Sorry!', 'Something went wrong...!', 'error');
        },
        () => {
          this.spinnerService.stop();
          if (this.employeeConfigItems == null || this.employeeConfigItems.length === 0) {
            this.loadEmployeeDetails();
            swal.fire('Sorry', 'No result found.', 'error');
          } else {
            this.employeeService.clearUserRoleSearchDetails();
            this.employeeService.setUserRoleSearchDetails(
              this.employeeConfigItems
            );
          }
        }
      );
    } else {
      this.validateAllFormFields(this.employeeForm);
      swal.fire('Error', msg, 'error');
    }
  }

  validateAllFormFields(formGroup: FormGroup) {

    Object.keys(formGroup.controls).forEach(field => {

      const control = formGroup.get(field);
      if (control instanceof FormControl) {

        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {

        this.validateAllFormFields(control);
      }
    });
  }

  onClickReset(): void {
    this.employeeForm.reset({
      employeeDesignation: null,
      name: null,
      states: null,
    });
    this.onLoadGetData();
  }

  onClickNew() {
    const modalRef = this.modalService.open(EmployeePopupComponent, {
      windowClass: 'xlModal'
    });
    // modalRef.componentInstance.name = 'Add New Employee';
    modalRef.componentInstance.selectedMode = ActionMode.ADD;
    modalRef.result.then((data: string) => {
      if (data == 'Saved') {
        this.onLoadGetData();
        this.loadEmployeeDetails();
        this.loadEmployeeDesignations();
      }
    }, () => {

    });
  }
}
